import React from 'react';

const Register = () => {

  const campuses = [
    {
      nombre: "Plantel Tula de Allende HGO..",
      direccion: "Calz. Melchor Ocampo 204, centro Tula de Allende, Hgo",
      horario: "Lunes a Jueves de 8:00 a 18:00 hrs. Sábado: 8:00 a 14:00 hrs.",
      telefono: "Fijo: 7737327604 WhatsApp: 7731345639",
      correo: "grupoimpulsoreducativotula@gmail.com"
    },
    {
      nombre: "Plantel Maravatio, MICH.",
      direccion: "Belizario Dominguez 162. Centro, Maravatio, Michoacan",
      horario: "Lunes a Jueves de 8:00 a 18:00 hrs. Sábado: 8:00 a 14:00 hrs.",
      telefono: "Fijo: 4474784708  WhatsApp: 4474784708",
      correo: "giMaravatio@outlook.com"
    },
    {
      nombre: "Plantel Acámbaro, GTO.",
      direccion: "Plaza Garlop, centro, Acambaro Gto",
      horario: "Lunes a Jueves de 8:00 a 18:00 hrs. Sábado: 8:00 a 14:00 hrs.",
      telefono: "Fijo: 7711234567  WhatsApp: 7711234568",
      correo: "Royal School: roxalschoolacambarogto@gmail.com / Instituto Royal: institutoroxalempario@gmail.com / Escuela Barberia: donporFirio71@gmail.com"
    },
  ];

  return (
    <div style={{ fontFamily: 'Poppins, sans-serif', padding: '20px', backgroundColor: '#f4f7fc' }}>
      {campuses.map((campus, index) => (
        <section key={index} style={{ marginBottom: '20px' }}>
          <h2 style={{ color: '#000000', fontWeight: '500', textAlign: 'center', fontSize: '1rem' }}>
            {campus.nombre.toUpperCase()}
          </h2>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', flexWrap: 'wrap' }}>
            {[{ label: "Dirección", content: campus.direccion },
            { label: "Horario", content: campus.horario },
            { label: "Teléfono", content: campus.telefono },
            { label: "Correo", content: campus.correo }
            ].map((item, i) => (
              <div key={i} style={{
                backgroundColor: 'white',
                width: '205px',
                textAlign: 'center',
                border: '1px solid #e1e7f0',
                borderRadius: '10px',
                padding: '10px'
              }}>
                <h4 style={{ color: '#0C8193', fontWeight: '500', marginBottom: '4px', fontSize: '0.8rem' }}>
                  {item.label}
                </h4>
                <p style={{ whiteSpace: 'pre-line', color: '#333', fontSize: '0.75rem' }}>
                  {item.content}
                </p>
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default Register;
